import { LDFlagValue } from 'launchdarkly-js-client-sdk';
import { useContext } from 'react';
import { LDContext, LDFlags } from '~/providers/launch-darkly';

export const useFlags = (flag: LDFlags): LDFlagValue => {
  const { allFlags } = useContext(LDContext);
  return allFlags()[flag];
};
